import React, { useContext } from 'react';
import {BrowserRouter, Switch, Route} from "react-router-dom";
import Navbar from './components/NavBar';
import Homepage from './components/Homepage';
import NewRecipe from './components/NewRecipe';
import Recipe from './components/Recipe';
import RecipeList from './components/RecipeList';
import UserContext from './context/UserContext';
import './styles/app.scss';
import IonutLogo from './styles/ionut_v.png';

function App() {

  const user = useContext(UserContext);

  return (
    <>
    <img className="ionut-logo" src={IonutLogo} alt="ionut-logo"/>
    <div className="app">
      <BrowserRouter>
      <Switch>
        {!user ? (
        <>
            <Homepage/>
        </>
        ) : (
          <>
          <div className="container">
            <Navbar user={user} />

            <Route exact path="/">
              <RecipeList />
            </Route>
          
            
            <Route path="/new">
              <NewRecipe />
            </Route>

            <Route path="/recipes/:id" component={Recipe}/>
            </div>
          </>
        )}

      </Switch>
      </BrowserRouter>
    </div>
    </>
  );
}

export default App;
